import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  sKey = "exsd2342Dsd";

  constructor(private http: HttpClient) { }

  /* Save Customer details in to session Storage*/
  saveToSession(key: string, data: any): void {
    let cdata = data;
    if (data && environment.production === true) {
      cdata = 'enc:' + CryptoJS.AES.encrypt(data.toString(), this.sKey).toString();
    }
    sessionStorage.setItem(key, cdata);
  }

  /* Load Customer details from session Storage*/
  loadFromSession(key: string): any {
    let data = sessionStorage.getItem(key);
    if (data && environment.production === true) {
      if (data.startsWith('enc:')) {
        const encData = data.substring(4);
        try {
          const bytes = CryptoJS.AES.decrypt(encData, this.sKey);
          data = bytes.toString(CryptoJS.enc.Utf8);
        } catch (e) {
          console.error('Decryption failed:', e);
          data = null;
        }
      }
    }
    return data;
  }

  /* Clear Customer details from session Storage when LOGOUT*/
  clearSession() {
    sessionStorage.clear();
  }

  clearSessionByName(name: string): void {
    sessionStorage.removeItem(name);
  }
  /* Save Customer ID in to local Storage*/
  saveToLocalStorage(customerId: any): any {
    localStorage.setItem('customerId', customerId);
  }

  /* Load CustomerID from session Storage*/
  loadFromLocalStorage(): any {
    return localStorage.getItem('customerId');
  }

  /* Clear Customer ID from local Storage when LOGOUT*/
  clearlocalStorage() {
    localStorage.clear();
  }
}
